export default __webpack_public_path__ + "static/media/share-provider.00c4b339.svg";